import React from 'react';
import AzTeam from './AzTeam';
import BrukerTeam from './BrukerTeam';
import BeckmanTeam from './BeckmanTeam';
import CollaboratorIntro from './CollaboratorIntro';
import '../../styles/collaborators/collaborators.css';

const About = () => {
	return (
		<div className='collaborators'>
            <CollaboratorIntro />
			<AzTeam />
			<BrukerTeam />
			<BeckmanTeam />
		</div>
	);
};

export default About;